import Skeleton from "react-loading-skeleton";
import styles from "./winners.module.css";

const Loader = () => (
  <section className="container mx-auto mt-5 mainSection">
    <div className="flex justify-center">
      <Skeleton highlightColor="rgb(255, 130, 0)" width={200} />
    </div>
    <Skeleton containerClassName={`${styles.winnersHighlight} h-96 flex`} />
    <Skeleton containerClassName={`${styles.winnersYearsFilter} h-20 flex`} />
    <div className={styles.categoriesAndSearchFilter}>
      <Skeleton count={2} inline highlightColor="#fff" containerClassName="grid grid-cols-2 gap-4 lg:px-60 h-10" />
    </div>
    <Skeleton
      highlightColor="#fff"
      count={5}
      inline
      height={300}
      containerClassName={"grid grid-cols-1 lg:grid-cols-2 gap-4 mt-5"}
    />
  </section>
);

export default Loader;
